import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { RiAdminFill } from "react-icons/ri";

import axios from "axios";
import swal from "sweetalert";
import { MdClose } from "react-icons/md";
import { Add } from "@mui/icons-material";

const EditCategoryModal = (props) => {
  const { setIsLoadingAdmin, setModalShowNewAdmin, refetch, setRefetch, id } =
    props;
  const [value, setValue] = useState();
  // if (isLoadingAdmin) {
  //     return <Loader></Loader>

  useEffect(() => {
    axios
      .get(`https://backend.studyswiftly.com/api/v1/category/category/${id}`)
      .then((res) => {
        console.log(res.data.categories, "res.data.categories");
        setValue(res.data.categories?.name);
      });
  }, [id]);
  // }
  const subNewAdmin = async (event) => {
    event.preventDefault();

    setIsLoadingAdmin(true);
    // const name = event.target.name.value;
    // console.log(name, "name");

    // const formDataAddAdmin = new FormData();
    // formDataAddAdmin.append("name", name);
    // formDataAddAdmin.append("category_name", name);

    await axios
      .put(`https://backend.studyswiftly.com/api/v1/category/category/${id}`, {
        name: value,
        category_name: value,
      })
      .then((res) => {
        if (res.status === 200) {
          // setAllAdmin(res.data.newAdmin);
          setIsLoadingAdmin(false);
          setModalShowNewAdmin(false);
          setRefetch(!refetch);
          event.target.reset();
          swal({
            title: "Success",
            text: `Category Added`,
            icon: "success",
            button: "OK!",
            className: "modal_class_success",
          });
          // alert(res.data.message);
        }
      })
      .catch((error) => {
        // alert(error.response.data.message);
        // console.log(error);
        setIsLoadingAdmin(false);
        swal({
          title: "Attention",
          text: `${error.response.data.message}`,
          icon: "warning",
          button: "OK!",
          className: "modal_class_success",
        });
      });
    // setIsLoadingAdmin(false);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header style={{ backgroundColor: "#272d47", color: "white" }}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="fs-5 text-light">
          <Add className="fs-4"></Add> Edit Category
        </Modal.Title>
        <MdClose
          onClick={props.onHide}
          color="#fff"
          size={30}
          style={{ cursor: "pointer" }}
        />
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#272d47", color: "white" }}>
        <div>
          <div>
            <form onSubmit={subNewAdmin}>
              <div className="row addAdminDiv">
                <div className="col-lg-12">
                  <p className="mb-1">Category Name</p>
                  <input
                    className="form-control"
                    placeholder="Category Name"
                    type="text"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    name="name"
                    required
                  />
                </div>
                <Modal.Footer className="mt-5">
                  <button
                    type="button"
                    className="adminBtnAdd11 text-uppercase"
                    onClick={props.onHide}>
                    Cancel
                  </button>
                  <button type="submit" className="adminBtnAdd text-uppercase">
                    Save
                  </button>
                </Modal.Footer>
              </div>
            </form>
          </div>
          <div></div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditCategoryModal;
